import {
	removeTranslationCode
} from '../services/product-translation.service';

import { ProductConfiguration } from './product-configuration';
import {
	OfferHeaderId,
	ProductRef
} from './product';

const PREFIX_OFFER_PRODUCT_ID_EOFFER = 'e';
const PREFIX_OFFER_PRODUCT_ID_CRM = 'c';

export function offerHeaderIdCreate(id: OfferHeaderId) {
	if (id.externalId) {
		return `${ PREFIX_OFFER_PRODUCT_ID_CRM }${ id.externalId }`;
	}
	if (id.id) {
		return `${ PREFIX_OFFER_PRODUCT_ID_EOFFER }${ id.id }`;
	}
	throw new Error('offer id not found');
}

export function offerProductRefEquals(r1: ProductRef, r2: ProductRef) {
	if (r1.ufoProductRef !== undefined || r2.ufoProductRef !== undefined) {
		return r1.ufoProductRef === r2.ufoProductRef;
	}
	return (
		r1.description.productRef !== undefined
		&& r1.description.productRef === r2.description.productRef
	)
	|| (
		r1.description.configurationRef !== undefined
		&& r1.description.configurationRef === r2.description.configurationRef
	);
}

export function productDimensionFromProductConfiguration(product: ProductConfiguration) {
	const unit = removeTranslationCode(product.unitOfDimensionsCode);
	return {
		thickness: {
			value: Number(product.thicknessValue),
			unit
		},
		width: {
			value: Number(product.widthValue),
			unit
		},
		length: product.lengthValue
			? {
				value: Number(product.lengthValue),
				unit
			}
			: undefined
	};
}

export function productFamilyParse(productFamilyCode: string) {
	const parts = productFamilyCode.split('#');
	return {
		category: parts[0],
		categoryDescription: '',
		subCategory: parts[1],
		subCategoryDescription: '',
		form: parts[2],
		formDescription: '',
		code: productFamilyCode,
		customerTemplate: []
	};
}

export function offerCreateDefault() {
	return {
		header: {}
	};
}
